import Footer from "../../components/Footer";
import PG_1 from "../../assets/img/pg_1.png";
import PG_2 from "../../assets/img/pg_2.png";
import PG_3 from "../../assets/img/pg_3.png";
import "../style.css";
import { useParams } from "react-router-dom";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
export default function PersonalisedGuidence() {
  const { id } = useParams();
  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "Free expert support tailored to your study goals",
      desc: "Our complimentary application assistance is designed to guide you at every step and improve your chances of securing admission to a Global university or college.",
      img: PG_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Get expert advice for your Global university application",
      desc: "Applying to universities and colleges in the Global requires careful planning and a clear understanding of entry requirements, deadlines, and necessary documents. With highly competitive admissions, a strong application is essential to secure your place at your preferred institution.Global StudyIn’s free university application service provides expert guidance at every stage – from course selection and eligibility checks to personal statement refinement and document preparation. With support from our specialist counsellors, you’ll gain the tools and confidence to submit an outstanding application.",
    },
    thirdSection: {
      rightSection: {
        img: PG_3,
      },
      leftSection: {
        header: "What is included?",
        desc: " With a 98% success rate, our Free Support service is designed to make your university application process as straightforward as possible. Here's what we offer:",
      },
      leftColumnContent: [
        {
          title: "Free 40-minute consultation",
          description:
            "Connect with a university expert, either in person or online, to explore your Global study options and clarify your next steps.",
        },
        {
          title: "University recommendations",
          description:
            "Get a tailored list of universities suited to your academic background, goals, and personal preferences.",
        },
        {
          title: "Complete application support",
          description:
            "Receive professional assistance in filling out and reviewing your application forms to ensure accuracy and completeness.",
        },
        {
          title: "University offer guidance",
          description:
            "Get support in comparing and selecting the most suitable university offer based on your academic and career objectives.",
        },
        {
          title: "Scholarship guidance",
          description:
            "Discover available scholarships and funding options to support your Global education financially.",
        },
        {
          title: "Documentation assistance",
          description:
            "Understand the required documents, including transcripts, reference letters, and other essential paperwork for submission.",
        },
        {
          title: "Personal statement enhancement",
          description:
            "Improve and refine your personal statement with expert feedback to effectively highlight your strengths and ambitions.",
        },
        {
          title: "Continuous application support",
          description:
            "Benefit from expert guidance throughout the entire process — from application submission to final enrolment.",
        },
      ],
      rightColumnContent: [

      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "Free expert support tailored to your study goals",
      desc: "Our complimentary application assistance is designed to guide you at every step and improve your chances of securing admission to a Global university or college.",
      img: PG_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Get expert advice for your Global university application",
      desc: "Applying to universities and colleges in the Global requires careful planning and a clear understanding of entry requirements, deadlines, and necessary documents. With highly competitive admissions, a strong application is essential to secure your place at your preferred institution.Global StudyIn’s free university application service provides expert guidance at every stage – from course selection and eligibility checks to personal statement refinement and document preparation. With support from our specialist counsellors, you’ll gain the tools and confidence to submit an outstanding application.",
    },
    thirdSection: {
      rightSection: {
        img: PG_3,
      },
      leftSection: {
        header: "What is included?",
        desc: " With a 98% success rate, our Free Support service is designed to make your university application process as straightforward as possible. Here's what we offer:",
      },
      leftColumnContent: [
        {
          title: "Free 40-minute consultation",
          description:
            "Connect with a university expert, either in person or online, to explore your Global study options and clarify your next steps.",
        },
        {
          title: "University recommendations",
          description:
            "Get a tailored list of universities suited to your academic background, goals, and personal preferences.",
        },
        {
          title: "Complete application support",
          description:
            "Receive professional assistance in filling out and reviewing your application forms to ensure accuracy and completeness.",
        },
        {
          title: "University offer guidance",
          description:
            "Get support in comparing and selecting the most suitable university offer based on your academic and career objectives.",
        },
        {
          title: "Scholarship guidance",
          description:
            "Discover available scholarships and funding options to support your Global education financially.",
        },
        {
          title: "Documentation assistance",
          description:
            "Understand the required documents, including transcripts, reference letters, and other essential paperwork for submission.",
        },
        {
          title: "Personal statement enhancement",
          description:
            "Improve and refine your personal statement with expert feedback to effectively highlight your strengths and ambitions.",
        },
        {
          title: "Continuous application support",
          description:
            "Benefit from expert guidance throughout the entire process — from application submission to final enrolment.",
        },
      ],
      rightColumnContent: [],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    enablePaymentRedirection: true
  };
  const data = (id == 1 || id == "free") ? learnMoreDataCourseFinder : learnMoreDataServices;
  return (
    <div className="personalised-guidance">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
